'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _paymentModal = require('./payment-modal');

var _paymentModal2 = _interopRequireDefault(_paymentModal);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _enterpriseAgreementPricingSummary = require('./enterprise-agreement-pricing-summary');

var _enterpriseAgreementPricingSummary2 = _interopRequireDefault(_enterpriseAgreementPricingSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var EnterpriseAgreement = _react2['default'].createClass({
    displayName: 'EnterpriseAgreement',


    propTypes: {
        'fullName': _react2['default'].PropTypes.string, // Full name of the person agreeing
        'email': _react2['default'].PropTypes.string.isRequired, // Their email address
        'companyName': _react2['default'].PropTypes.string, // Their company name
        'billingName': _react2['default'].PropTypes.string, // Optional billing contact name, if different
        'billingEmail': _react2['default'].PropTypes.string, // Optional billing contact email, if different
        'numSeats': _react2['default'].PropTypes.number.isRequired, // Number of seats on the plan
        'totalRate': _react2['default'].PropTypes.string.isRequired, // Total rate (formatted)
        'periodName': _react2['default'].PropTypes.string.isRequired, // Billing period (month or year)
        'features': _react2['default'].PropTypes.array.isRequired, // List of features { name, [code], [value], enabled }
        'paymentForm': _react2['default'].PropTypes.object.isRequired, // Serialized payment form
        'paymentInfo': _react2['default'].PropTypes.object.isRequired, // Payment information { card, subscription, ... }
        'siteCode': _react2['default'].PropTypes.string.isRequired, // Site code
        'isApi': _react2['default'].PropTypes.bool.isRequired, // Whether it's for an API plan
        'termsAccepted': _react2['default'].PropTypes.bool, // If they've already accepted the terms
        'numApiSigRequests': _react2['default'].PropTypes.number, // Number of API signature requests
        'couponInfo': _react2['default'].PropTypes.object, // API coupon information { percentage, duration }
        'isFreeTrial': _react2['default'].PropTypes.bool, // Whether to give the user a free trial
        'billingType': _react2['default'].PropTypes.string,
        'billingMethod': _react2['default'].PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'termsAccepted': false
        };
    },
    continueClicked: function continueClicked(evt) {
        if (this.isAlternateBilling()) {
            this.submitForm();
        } else {
            this.launchPaymentModal(evt);
        }
    },
    isAlternateBilling: function isAlternateBilling() {
        var _this = this;

        return _constants2['default'].ALTERNATIVE_BILLING_TYPES.filter(function (type) {
            return type === _this.props.billingType;
        }).length > 0;
    },
    launchPaymentModal: function launchPaymentModal(evt) {

        var target = $(evt.target);
        if (!target.hasClass('m-button') && target.parents('.m-button').length === 0) {
            return;
        }

        evt.preventDefault();

        var attachPoint = HfReactHelper.getRevealAttachPoint('payment_modal', this.props.paymentInfo.card ? 'small' : 'medium');
        var d = this.props.paymentInfo;
        var cc = d.card;
        var s = d.subscription;
        var n = this.props.numSeats;

        var cardholder = '';
        if (cc) {
            cardholder = cc.holderName;
        } else if (this.props.billingName && this.props.billingEmail !== this.props.email) {
            cardholder = this.props.billingName;
        }

        // NOTE: isFreeTrial will force free-trial eligibility for enterprise customers, if it's been set
        _reactDom2['default'].render(_react2['default'].createElement(_paymentModal2['default'], {
            key: 'paymentModal_' + d.planId,
            planId: d.planId,
            isFreeTrialEligible: this.props.isFreeTrial,
            forceFreeTrial: this.props.isFreeTrial,
            price: d.price,
            timePeriod: s.timePeriod,
            monthlyExpectedRate: s.monthlyExpectedRate * n,
            annualExpectedRate: s.annualExpectedRate * n,
            monthlyProratedRate: s.monthlyProratedRate * n,
            annualProratedRate: s.annualProratedRate * n,
            currentMonthlyRate: s.currentMonthlyRate * n,
            currentAnnualRate: s.currentAnnualRate * n,
            proratio: s.proratio,
            couponCode: s.couponCode,
            ccSuffix: cc ? cc.suffix : '',
            ccExpiration: cc ? cc.expiration : '',
            cardHolderName: cardholder,
            name: d.name,
            isApi: d.isApi || false,
            termsAccepted: this.props.termsAccepted,
            paymentForm: this.props.paymentForm,
            numSeats: this.props.numSeats,
            headerText: 'Enterprise Plan' }), attachPoint);
    },
    submitForm: function submitForm() {
        $('#agreementForm').submit();
    },
    render: function render() {

        var name, company, onBehalfOf;
        var continueButton, ctaSubText;
        var paymentModal;
        var features = [];
        var hasSeparateBillingContact = this.props.billingEmail && this.props.billingEmail !== this.props.email;

        // Header
        if (this.props.fullName || this.props.billingName) {
            name = _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--header--name' },
                hasSeparateBillingContact ? this.props.billingName : this.props.fullName
            );
        }
        if (this.props.companyName) {
            company = _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--header--company' },
                this.props.companyName
            );
        }
        if (hasSeparateBillingContact) {
            onBehalfOf = _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--header--on-behalf-of' },
                'On behalf of ',
                this.props.fullName,
                ' (',
                this.props.email,
                ')'
            );
        }

        // Features
        var i = -1;
        var n = this.props.features.length;
        var feature, featureClasses, featureValue, hasValue;
        var hasHipaa = false;
        for (var k in this.props.features) {
            feature = this.props.features[k];
            hasValue = false;
            if (feature.enabled === undefined || feature.enabled === true) {
                if (!hasHipaa && feature.code === HfReactHelper.HfConstants.enterpriseFeatures.HIPAA) {
                    hasHipaa = true;
                }
                hasValue = feature.value !== undefined;
                featureClasses = (0, _classnames2['default'])({
                    'm-plan-agreement--features--table--item': true,
                    'with-value': hasValue,
                    'is-left': ++i % 2 === 0,
                    'is-bottom': n % 2 === 0 && i >= n - 2 || n % 2 === 1 && i === n - 1,
                    'is-top': i < 2
                });
                featureValue = hasValue ? _react2['default'].createElement(
                    'div',
                    { className: 'm-plan-agreement--features--table--item--value' },
                    feature.value === null ? 'UNLIMITED' : feature.value
                ) : undefined;
                features.push(_react2['default'].createElement(
                    'div',
                    { key: 'feature-' + feature.name, className: featureClasses },
                    featureValue,
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-plan-agreement--features--table--item--name' },
                        feature.name
                    )
                ));
            }
        }

        // Continue button
        continueButton = _react2['default'].createElement(_button2['default'], {
            key: 'agreementContinueButton',
            buttonText: 'Continue',
            buttonLink: '#',
            buttonColor: 'cerulean',
            buttonTextColor: 'white' });

        // HIPAA warning
        if (hasHipaa) {
            var siteName = HfReactHelper.HfSites.getSiteName(this.props.siteCode);
            ctaSubText = 'Upon payment, your account will be configured for HIPAA compliance. ' + 'It is your responsibility to continue to use ' + siteName + ' in a HIPAA compliant manner.';
        }

        // Dollars and cents
        var totalRate = this.props.totalRate.split('.');
        totalRate = _react2['default'].createElement(
            'span',
            null,
            totalRate[0],
            totalRate[1] ? _react2['default'].createElement(
                'span',
                { className: 'm-plan-agreement--summary--cents' },
                totalRate[1]
            ) : undefined
        );

        return _react2['default'].createElement(
            'div',
            { className: 'm-plan-agreement small-12' },
            _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--header l-margin-b-40' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-plan-agreement--header--title' },
                    'PLAN DETAILS'
                ),
                name,
                _react2['default'].createElement(
                    'div',
                    { className: 'm-plan-agreement--header--email' },
                    hasSeparateBillingContact ? this.props.billingEmail : this.props.email
                ),
                onBehalfOf,
                company,
                _react2['default'].createElement(
                    'p',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        this.props.isApi ? this.props.numApiSigRequests : this.props.numSeats,
                        this.props.isApi ? ' signature requests per month' : ' senders'
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--summary l-margin-b-40 small-12' },
                _react2['default'].createElement(_enterpriseAgreementPricingSummary2['default'], {
                    couponInfo: this.props.couponInfo,
                    totalRate: this.props.totalRate,
                    discountedRate: this.props.discountedTotalRate,
                    periodName: this.props.periodName,
                    isFreeTrial: this.props.isFreeTrial,
                    billingType: this.props.billingType,
                    billingMethod: this.props.billingMethod
                })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--features small-12 l-margin-b-40' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-plan-agreement--features--title' },
                    'FEATURES'
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-plan-agreement--features--table' },
                    features
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-plan-agreement--cta small-12' },
                _react2['default'].createElement(
                    'div',
                    { onClick: this.continueClicked },
                    continueButton
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-plan-agreement--cta--text' },
                    ctaSubText
                )
            ),
            _react2['default'].createElement('form', { id: 'agreementForm', method: 'POST', action: '' }),
            paymentModal
        );
    }
});

module.exports = EnterpriseAgreement;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/enterprise-agreement.jsx
 ** module id = 1125
 ** module chunks = 0
 **/